import Vue from "vue"

function showInLang(value, currlang) {
    switch (currlang) {
        case 'pl':
            if (value != null)
                if (value.pl != undefined && value.pl != "")
                    return value.pl;
            return "Brak informacji";
        case 'en':
            if (value != null)
                if (value.en != undefined && value.en != "")
                    return value.en;
            return "No information";
        case 'de':
            if (value != null)
                if (value.de != undefined && value.de != "")
                    return value.de;
            return "Keine Informationen";
        default:
            return value.pl;
    }
}

Vue.filter("showInLang", showInLang)
Vue.filter("showInLangField", function (value, currlang) {
    switch (currlang) {
        case 'pl':
            if (value != null)
                if (value != undefined && value != "")
                    return value;
            return "Brak informacji";
        case 'en':
            if (value != null)
                if (value != undefined && value != "")
                    return value;
            return "No information";
        case 'de':
            if (value != null)
                if (value != undefined && value != "")
                    return value;
            return "Keine Informationen";
        default:
            return value;
    }
})
Vue.filter("showInLangAvatar", function (value, currlang) {
    switch (currlang) {
        case 'pl':
            if (value != null)
                if (value != undefined && value != "")
                    return value;
            return "Brak avatara";
        case 'en':
            if (value != null)
                if (value != undefined && value != "")
                    return value;
            return "No avatar";
        case 'de':
            if (value != null)
                if (value != undefined && value != "")
                    return value;
            return "Kein Avatar";
        default:
            return value;
    }
})

function booleanToLang(value, currlang) {
    switch (currlang) {
        case 'pl':
            if (value == false)
                return "Nie";
            else
                return "Tak";
        case 'en':
            if (value == false)
                return "No";
            else
                return "Yes";
        case 'de':
            if (value == false)
                return "Ja";
            else
                return "Nein";
        default:
            return value;
    }
}

Vue.filter("showInLangTrueFalse", booleanToLang)

const POSSIBILITIES = {
    tak: {
        pl: "Tak",
        en: "Yes",
        de: "Ja"
    },
    nie: {
        pl: "Nie",
        en: "No",
        de: "Nein"
    },
    do_ustalenia: {
        pl: "Do ustalenia z operatorem sieci",
        en: "To be agreed with the network operator",
        de: "Mit dem Netzbetreiber abzustimmen"
    }
}

const ND_POSSIBILITY = {
    pl: "Brak informacji",
    en: "No information",
    de: "Keine Informationen",
}

Vue.filter("showInLangPossibility", function (value, currlang) {
    let p = POSSIBILITIES[value] || ND_POSSIBILITY
    return p[currlang]
})

Vue.filter("showInLang_ImportBoolean", function (value, currlang) {
    // correct invalid import
    // return showInLang(value, currlang);
    switch (value && value.pl) {
        case 'True':
            return booleanToLang(true, currlang);
        case 'False':
            return booleanToLang(false, currlang);
        default:
            return showInLang(value, currlang);
    }
})


Vue.filter("capitalize", function (value) {
    if (!value) return "";
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
})
Vue.filter("parseToIntM2", function (value) {
    return Math.round(value) + "m";
})
Vue.filter("roundTo2Places", function (value) {
    if (!value) {
        return 0;
    }
    if (typeof (value.toFixed) != 'function') {
        return 0;
    }
    return !value ? value : value.toFixed(2);
})
Vue.filter("roundTo4Places", function (value) {
    return !value ? value : value.toFixed(4);
})
Vue.filter("removeCommunityName", function (value) {
    return !value ? value : value.replace('gmina ', '');
})

Vue.filter("outlaysEnterprise", function (value, currlang) {
    switch (currlang) {
        case 'pl':
            if (value == "duze")
                return "Duże firmy";
            if (value == "srednie")
                return "Średnie firmy";
            if (value == "male")
                return "Małe firmy";
            if (value == "mikro")
                return "Mikro firmy";
            return "Brak informacji";
        case 'en':
            if (value == "duze")
                return "Big companies";
            if (value == "srednie")
                return "Medium companies";
            if (value == "male")
                return "Small companies";
            if (value == "mikro")
                return "Micro companies";
            return "No information";
        case 'de':
            if (value == "duze")
                return "Groß Unternehmen";
            if (value == "srednie")
                return "Durchschnitt Unternehmen";
            if (value == "male")
                return "Klein Unternehmen";
            if (value == "mikro")
                return "Mikro Unternehmen";
            return "Keine Informationen";
        default:
            return value;
    }
})